// extracted by mini-css-extract-plugin
export default {"wrapper":"BookingCancelDialog_wrapper__15yDA","content":"BookingCancelDialog_content__GvhJO","footer":"BookingCancelDialog_footer__5Ehdz"};